import React from "react"
import propTypes from "prop-types"
import "./styles.scss"

import Button from "../Button"

const AlertPopup = ({
  className,
  isHidden,
  type,
  title,
  description,
  onClose
}) => {
  return (
    <div
      className={[
        "alert-popup",
        className,
        `${!isHidden ? "alert-popup--show" : ""}`
      ].join(" ")}
    >
      <div className="alert-popup_inner">
        <div className="alert-popup_container">
          <div className="alert-popup_title">{title}</div>

          <div className="alert-popup_description">{description}</div>

          <div className="alert-popup_icon">
            {(() => {
              switch (type) {
                case "success":
                  return (
                    <div className="alert-popup_icon_img alert-popup_icon_img--success" />
                  )
                default:
                  return "Unknown alert type"
              }
            })()}
          </div>

          <Button
            button={{ type: "button" }}
            onClick={onClose}
            className="btn btn--secondary-light btn--width-lg btn--height-sm btn--font-size-md"
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
  )
}

AlertPopup.defaultProps = {
  className: ""
}

AlertPopup.propTypes = {
  title: propTypes.string.isRequired,
  description: propTypes.string.isRequired,
  className: propTypes.string,
  isHidden: propTypes.bool.isRequired,
  type: propTypes.string.isRequired,
  onClose: propTypes.func.isRequired
}

export default AlertPopup
